import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ServiceProjectStoreModule } from './project/project-store.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ServiceProjectStoreModule
  ]
})
export class ServiceStoreModule { }
